{
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "user": "Usuario",
    "total_earned": "Total Ganado",
    "current_balance": "Saldo Actual",
    "affiliate_link": "Enlace de Afiliado",
    "share_link": "Comparte tu enlace para invitar y ganar.",
    "copy": "Copiar",
    "total_commissions": "Comisiones Totales",
    "career_plan": "Plan de Carrera",
    "current_level": "Actualmente estás en el nivel",
    "next_level": "Avanza al nivel",
    "next_level_short": "Próximo nivel",
    "current_bonus": "Bono actual",
    "next_bonus": "Próximo bono",
    "residual_note": "Recibes un 1% recurrente del PLR de tus referidos directos hasta la 5ª generación.",
    "my_quotas": "Mis Cuotas",
    "view_all": "Ver todas",
    "value": "Valor",
    "created_at": "Creada en",
    "finished_at": "Finaliza en",
    "status": "Estado",
    "status_finished": "Finalizada",
    "status_in_progress": "En progreso",
    "copied_success": "Enlace copiado con éxito",
    "load_error": "Error al cargar el panel",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub",
    "nova_stake": "Nueva Stake",
    "sacar": "Retirar",
    "trazer_corretora": "Traer de la Corredora",
    "saldo": "Saldo",
    "deposit": "Depósito",
    "sair": "Salir",
    "historico": "Historial"
  },
  "sidebar": {
    "dashboard": "Inicio",
    "stake": "Stake",
    "content_education": "Contenido educativo",
    "history": "Historial",
    "network": "Red",
    "copytrade": "Copytrade",
    "operations": "Operaciones",
    "earnings": "Ganancias",
    "primezord": "Primezord",
    "support": "Soporte",
    "saldo_disponivel": "Saldo disponible",
    "voltar_corretora": "Volver a la Corredora",
    "tempo_sessao": "Tiempo restante de sesión"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Subir archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Seleccionar una opción"
  },
  "stakes": {
    "start_date": "Fecha de Contratación",
    "create_in": "Fecha de Contratación",
    "duration": "Plazo",
    "status": "Estado",
    "status_active": "En curso",
    "status_Finalizada": "Finalizada",
    "amount": "Monto de la Stake",
    "profit": "Ganancia Generada",
    "my_quotas": "Mis Cuotas",
    "create_new": "Crear nueva cuota",
    "empty_title": "Aún no tienes cuotas",
    "empty_subtitle": "Crea tu primera cuota para comenzar.",
    "create_first": "Crear mi primera cuota",
    "progress": "Progreso",
    "cancel_button": "Cancelar Stake",
    "modal_title": "Cancelar Stake",
    "modal_description": "¿Estás seguro de que deseas cancelar la stake por el valor de",
    "modal_close": "Cerrar",
    "modal_confirm": "Confirmar Cancelación"
  },
  "history": {
    "copytrade": "CopyTrade",
    "stakes": "Stakes",
    "operacoes": "Operaciones",
    "saques": "Retiros",
    "bonus": "Bono",
    "residual": "Residual",
    "primezord": "Primezord",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "status": {
      "canceled": "Cancelado",
      "complete": "Completo",
      "in_progress": "En progreso",
      "finished": "Finalizada"
    },
    "columns": {
      "date": "Fecha",
      "value": "Valor",
      "status": "Estado",
      "invested": "Monto Invertido",
      "profit": "Ganancia Generada",
      "pair": "Par",
      "payout": "Pago",
      "description": "Descripción",
      "source": "Origen",
      "reference": "Referencia",
      "total": "Total",
      "percentage": "Porcentaje",
      "notes": "Notas"
    }
  },
  "network": {
    "email": "Correo",
    "phone": "Teléfono",
    "balance": "Saldo",
    "loading": "Cargando red..."
  },
  "copytrade": {
    "title": "CopyTrades Contratados",
    "create": "Crear Nuevo CopyTrade",
    "empty": "Ningún CopyTrade contratado actualmente.",
    "start_date": "Fecha de Inicio",
    "status": "Estado",
    "status_active": "En curso",
    "status_expired": "Expirado",
    "invested": "Capital Invertido",
    "profit": "Ganancia Generada",
    "modal_title": "Crear nuevo CopyTrade",
    "modal_description": "Seleccione el monto que desea invertir.",
    "investment_amount": "Monto de la Inversión",
    "select": "Seleccione...",
    "start_copy": "Iniciar CopyTrade",
    "cancel": "Cancelar",
    "alert_select_amount": "Seleccione un monto"
  },
  "operations": {
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "asset": "Activo",
    "all": "Todos",
    "loading": "Cargando operaciones...",
    "columns": {
      "date": "Fecha",
      "asset": "Activo",
      "payout": "Pago"
    }
  },
  "primezord": {
    "title": "Primezord",
    "deposit": "Depósito",
    "withdraw": "Retiro",
    "invest": "Inversión",
    "modal_deposit": "Realizar Depósito",
    "modal_withdraw": "Solicitar Retiro",
    "modal_invest": "Nueva Inversión",
    "modal_subtitle": "Seleccione el monto deseado.",
    "modal_value": "Monto",
    "modal_confirm": "Confirmar",
    "modal_cancel": "Cancelar",
    "balance_label": "Saldo Zord",
    "withdraw_balance_label": "Disponible para Retiro",
    "taxa": "Tasa del dólar",
    "table_date": "Fecha",
    "table_value": "Monto",
    "table_status": "Estado",
    "loading": "Cargando inversiones...",
    "blocked_balance_label": "Bloqueado",
    "alert_value": "Seleccione un monto"
  },
  "profile": {
    "title": "Actualizar Perfil",
    "avatarTitle": "Foto de Perfil",
    "selectImage": "Seleccione una imagen.",
    "saveAvatar": "Guardar Avatar",
    "personalInfo": "Información Personal",
    "phone": "Teléfono",
    "birth": "Fecha de nacimiento",
    "saveData": "Guardar Datos",
    "changePassword": "Cambiar Contraseña",
    "newPassword": "Nueva Contraseña",
    "confirmPassword": "Confirmar Contraseña",
    "savePassword": "Guardar Contraseña",
    "updatedSuccess": "Actualizado con éxito.",
    "updatedError": "Error al actualizar.",
    "passwordMismatch": "Las contraseñas no coinciden.",
    "avatar_title": "Foto de Perfil",
    "account_data": "Datos de la Cuenta",
    "birthday": "Fecha de nacimiento",
    "new_password": "Nueva Contraseña",
    "confirm_password": "Confirmar Contraseña",
    "save": "Guardar Todo"
  },
  "support": {
    "title": "Habla con Soporte",
    "description": "Ya sea para hacer preguntas, resolver un problema o simplemente hablar con nuestro equipo, estamos listos para ayudarte. ¡Elige tu canal preferido y habla con nosotros! Nuestro soporte está hecho por personas reales, con atención rápida y humanizada. 😉"
  },
  "modal": {
    "newQuota": "Nueva Cuota",
    "confirmation": "Confirmación",
    "payment": "Pago",
    "choosePlan": "Elija el plan",
    "quotaValue": "Valor de la Cuota:",
    "continue": "Continuar",
    "confirmPurchase": "¿Está seguro de que desea adquirir la cuota del plan {plan} por $ {amount}?",
    "acceptTerms": "He leído y acepto los",
    "termsOfUse": "términos de uso",
    "confirm": "Confirmar",
    "paymentValue": "Pago $ {amount}.",
    "paymentInstruction": "Complete el pago usando el código QR o copie la línea PIX a continuación.",
    "pixLine": "Línea digitada",
    "copy": "Copiar",
    "back": "Volver",
    "loading": "Cargando",
    "finish": "Finalizar",
    "alert_message": "⚠\uFE0F La confirmación del pago puede tardar hasta 1 hora. ¡No te preocupes, te avisaremos en cuanto esté todo listo!"
  },
  "earnings": {
    "title": "Ganancias",
    "start_date": "Fecha Inicio",
    "end_date": "Fecha Fin",
    "date": "Fecha",
    "amount": "Monto",
    "action": "Acción",
    "download": "Descargar PDF",
    "loading": "Cargando ganancias..."
  }
}
